import React from 'react';
import { Helmet } from 'react-helmet';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Import components
import Header from './components/Header';
import Footer from './components/Footer';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import pages
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';
import SubcategoryPage from './pages/SubcategoryPage';
import ListingPage from './pages/ListingPage';
import InvestorPage from './pages/InvestorPage';
import RelocationPage from './pages/RelocationPage';
import SearchPage from './pages/SearchPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <Router>
      <div className="App d-flex flex-column min-vh-100">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Jamaica Directory - Your Guide to Jamaica's Best</title>
          <meta name="description" content="Discover Jamaica's best historic sites, restaurants, pet services, marinas, golf courses and more with our comprehensive directory." />
          <meta name="keywords" content="Jamaica, directory, historic sites, restaurants, pet groomers, veterinarians, marinas, golf courses, tourism, relocation" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <link rel="canonical" href="https://jamaicadirectory.com" />
          <meta property="og:title" content="Jamaica Directory - Your Guide to Jamaica's Best" />
          <meta property="og:description" content="Discover Jamaica's best historic sites, restaurants, pet services, marinas, golf courses and more with our comprehensive directory." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://jamaicadirectory.com" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Jamaica Directory - Your Guide to Jamaica's Best" />
          <meta name="twitter:description" content="Discover Jamaica's best historic sites, restaurants, pet services, marinas, golf courses and more with our comprehensive directory." />
        </Helmet>
        <Header />
        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/category/:categoryId" element={<CategoryPage />} />
            <Route path="/category/:categoryId/:subcategoryId" element={<SubcategoryPage />} />
            <Route path="/listing/:categoryId/:subcategoryId/:listingId" element={<ListingPage />} />
            <Route path="/investor-resources" element={<InvestorPage />} />
            <Route path="/relocation-guide" element={<RelocationPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
